import { CommonModule } from '@angular/common';
import { Component, input, output, OnInit } from '@angular/core';
import { CarouselItem } from '../carousel-plans.model';
import { AppButtonComponent } from '../../app-button/app-button.component';

@Component({
  selector: 'app-carousel-plan-card',
  standalone: true,
  imports: [CommonModule, AppButtonComponent],
  templateUrl: './carousel-plan-card.component.html',
  styleUrl: './carousel-plan-card.component.scss'
})
export class CarouselPlanCardComponent implements OnInit {
  carouselCardData = input<any>();
  chunkCarouselSize = input<number>();
  isMobile = input<boolean>();
  templateVersion = input<number>();
  indexJ = input<number>();
  styles = input<any>();
  carouselAction = output<CarouselItem>();

  sortedEnableItems: any[] = [];

  isVila = window.location.hostname === 'vilanova.ingressosa.com.br';

  plansPastsValues = [
    {id: 'dcf12fad-4cde-4e54-8878-ac60fcc81c7e', value: 'R$ 250,00'}, //Rubi
    {id: '4b620617-539a-4288-89c6-1b395540bc68', value: 'R$ 115,00'}, //Ouro
    {id: 'e9f2539c-d369-4658-b091-11b7797b6be2', value: 'R$ 126,50'}, // Ouro semestral
    {id: 'bc61fede-bfcf-40a1-b2e0-84a083c2dc91', value: 'R$ 55,00'}, // Prata
    {id: 'e992db2e-a2ae-47e4-b0d0-3efc65803d92', value: 'R$ 60,50'}, // Prata Semestral
    {id: 'ed7b0321-5177-4a74-acc6-4581121d619e', value: 'R$ 20,00'} // Time do Povo
  ]

  ngOnInit(): void {
  }

    getPlanPastValue(planId: any){
    return this.plansPastsValues.find(p => p.id === planId)?.value;
  }

  buttonAction(plano: CarouselItem): void {
    this.carouselAction.emit(plano);
  }
}
